module.exports = __webpack_public_path__ + "static/liofilizat_sloik@0,75x-e2e6c9d3bc925bb45bd094a134dfc938.png";